// 代理企业模块多语言配置
export const agency = {
    'zh-CN': {
      // 代理企业管理页面
      pleaseEnterNameOrPhone: '请输入姓名或电话',
      query: '查询',
      enterpriseId: '企业ID',
      enterpriseName: '企业名称',
      administrator: '管理员',
      contactInfo: '联系方式',
      businessCardLimit: '名片数上限',
      enterpriseEmployeeCount: '企业员工数',
      startTime: '开始时间',
      expiryDuration: '到期时长',
      status: '状态',
      operation: '操作',
      detail: '详情',
      normal: '正常',
      expired: '已到期',
      
      // 企业详情页面
      enterpriseInfo: '企业信息',
      unauthorized: '未授权',
      person: '人',
      enterpriseLogo: '企业LOGO',
      industry: '所属行业',
      enterpriseNotice: '企业公告',
      enterpriseEmployee: '企业员工',
      customerCount: '客户人数',
      createTime: '创建时间',
      administratorInfo: '管理员信息',
      name: '姓名',
      position: '职位',
      phoneNumber: '手机号码',
      wechatNumber: '微信号',
      email: '邮箱',
      back: '返回'
    },
    'zh-TW': {
      // 代理企业管理页面
      pleaseEnterNameOrPhone: '請輸入姓名或電話',
      query: '查詢',
      enterpriseId: '企業ID',
      enterpriseName: '企業名稱',
      administrator: '管理員',
      contactInfo: '聯繫方式',
      businessCardLimit: '名片數上限',
      enterpriseEmployeeCount: '企業員工數',
      startTime: '開始時間',
      expiryDuration: '到期時長',
      status: '狀態',
      operation: '操作',
      detail: '詳情',
      normal: '正常',
      expired: '已到期',
      
      // 企业详情页面
      enterpriseInfo: '企業信息',
      unauthorized: '未授權',
      person: '人',
      enterpriseLogo: '企業LOGO',
      industry: '所屬行業',
      enterpriseNotice: '企業公告',
      enterpriseEmployee: '企業員工',
      customerCount: '客戶人數',
      createTime: '創建時間',
      administratorInfo: '管理員信息',
      name: '姓名',
      position: '職位',
      phoneNumber: '手機號碼',
      wechatNumber: '微信號',
      email: '郵箱',
      back: '返回'
    },
    'en': {
      // 代理企业管理页面
      pleaseEnterNameOrPhone: 'Please enter name or phone',
      query: 'Query',
      enterpriseId: 'Enterprise ID',
      enterpriseName: 'Enterprise Name',
      administrator: 'Administrator',
      contactInfo: 'Contact Info',
      businessCardLimit: 'Business Card Limit',
      enterpriseEmployeeCount: 'Enterprise Employee Count',
      startTime: 'Start Time',
      expiryDuration: 'Expiry Duration',
      status: 'Status',
      operation: 'Operation',
      detail: 'Detail',
      normal: 'Normal',
      expired: 'Expired',
      
      // 企业详情页面
      enterpriseInfo: 'Enterprise Info',
      unauthorized: 'Unauthorized',
      person: 'Person',
      enterpriseLogo: 'Enterprise Logo',
      industry: 'Industry',
      enterpriseNotice: 'Enterprise Notice',
      enterpriseEmployee: 'Enterprise Employee',
      customerCount: 'Customer Count',
      createTime: 'Create Time',
      administratorInfo: 'Administrator Info',
      name: 'Name',
      position: 'Position',
      phoneNumber: 'Phone Number',
      wechatNumber: 'WeChat Number',
      email: 'Email',
      back: 'Back'
    }
  };